/* Load more for collection grids (sections/main-collection-product-grid.liquid).
 * - Appends the next page in place via the Section Rendering API.
 * - Holds back a part-filled last row until the next batch arrives, so every row is full on any
 *   screen size. Nothing is held back once there is no next batch: the very end shows everything.
 * - After `data-cap` loads the button becomes a plain link to a fresh next page.
 * - Remembers how far the shopper loaded and where they were, so Back from a product restores it.
 */
(() => {
  const GRID = 'product-grid';
  const stateKey = () => {
    const p = new URLSearchParams(location.search); p.delete('page'); p.delete('section_id');
    return 'wps-lm:' + location.pathname + '?' + p.toString();
  };
  const root = () => document.querySelector('[data-wps-loadmore]');
  const grid = () => document.getElementById(GRID);
  const cols = (g) => getComputedStyle(g).gridTemplateColumns.split(' ').filter(Boolean).length;

  function trim() {
    const g = grid(), r = root(); if (!g) return;
    g.querySelectorAll('.wps-held').forEach((e) => e.classList.remove('wps-held'));
    const nb = r && r.querySelector('[data-wps-next]');
    // only hold back when the next batch will be appended HERE. At the end of the collection, or
    // once the cap has turned the button into a plain link to a fresh page, show everything, or
    // the held products would never be seen.
    if (!nb || nb.dataset.plain) return count();
    for (let pass = 0; pass < 4; pass++) {
      const items = [...g.children].filter((e) => !e.classList.contains('wps-held') && e.offsetParent !== null);
      const c = cols(g); if (!items.length || c < 2) return;
      const box = g.getBoundingClientRect(), rects = items.map((e) => e.getBoundingClientRect());
      const y = Math.max(...rects.map((q) => q.top)) + 4, colW = box.width / c;
      let filled = 0;
      for (let k = 0; k < c; k++) {
        const x = box.left + colW * (k + 0.5);
        if (rects.some((q) => x >= q.left && x <= q.right && y >= q.top && y <= q.bottom)) filled++;
      }
      if (filled === c) return count();                               // last row is full
      items.forEach((e, i) => { if (rects[i].top <= y && rects[i].bottom >= y) e.classList.add('wps-held'); });
    }
    count();
  }

  // "Showing 1-78 of 1,595": count the products actually on screen, not tiles or held ones
  function count() {
    const g = grid(), r = root(); if (!g || !r) return;
    const last = r.querySelector('[data-wps-last]'); if (!last) return;
    const shown = [...g.children].filter((e) => !e.classList.contains('wps-held') && !e.classList.contains('wps-roomshot-tile')).length;
    last.textContent = Math.min(+r.dataset.first + shown - 1, +r.dataset.total);
  }

  function save(extra) {
    const r = root(); if (!r) return;
    try {
      sessionStorage.setItem(stateKey(), JSON.stringify(Object.assign({
        start: +r.dataset.startPage || +r.dataset.page, end: +r.dataset.page, y: window.scrollY,
      }, extra || {})));
    } catch (e) {}
  }

  async function loadNext() {
    const r = root(), btn = r && r.querySelector('[data-wps-next]'); if (!btn) return false;
    if (!r.dataset.startPage) r.dataset.startPage = r.dataset.page;
    const url = new URL(btn.href, location.origin); url.searchParams.set('section_id', r.dataset.section);
    btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Loading…';
    let doc;
    try { doc = new DOMParser().parseFromString(await (await fetch(url)).text(), 'text/html'); }
    catch (e) { location.href = btn.href; return false; }               // fall back to a normal page load
    const incoming = doc.getElementById(GRID), next = doc.querySelector('[data-wps-loadmore]');
    if (!incoming || !next) { location.href = btn.href; return false; }
    const g = grid();
    g.querySelectorAll('.wps-held').forEach((e) => e.classList.remove('wps-held'));
    [...incoming.children].forEach((li) => g.appendChild(document.adoptNode(li)));
    r.dataset.page = next.dataset.page;
    const nb = next.querySelector('[data-wps-next]');
    if (nb) {
      btn.href = nb.getAttribute('href'); btn.removeAttribute('aria-busy');
      const loads = +r.dataset.page - +r.dataset.startPage;
      if (loads >= +r.dataset.cap) { btn.textContent = 'Next page'; btn.dataset.plain = '1'; }
      else btn.textContent = 'Load more';
    } else btn.remove();
    if (typeof initializeSwipeFunctionality === 'function') { try { initializeSwipeFunctionality(document.getElementById('ProductGridContainer')); } catch (e) {} }
    trim(); save();
    return true;
  }

  document.addEventListener('click', (ev) => {
    const btn = ev.target.closest('[data-wps-next]');
    if (btn && !btn.dataset.plain && !ev.metaKey && !ev.ctrlKey) { ev.preventDefault(); loadNext(); return; }
    if (ev.target.closest(`#${GRID} a`)) save();                       // remember the spot before leaving
  });

  async function restore() {
    const r = root(); if (!r) return;
    let st; try { st = JSON.parse(sessionStorage.getItem(stateKey()) || 'null'); } catch (e) {}
    const nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    const back = nav && nav.type === 'back_forward';
    if (!st || !back || st.start !== +r.dataset.page || st.end <= st.start) { trim(); return; }
    if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
    r.dataset.startPage = st.start;
    while (+r.dataset.page < st.end) { if (!(await loadNext())) break; }
    trim(); window.scrollTo(0, st.y);
  }

  let t; window.addEventListener('resize', () => { clearTimeout(t); t = setTimeout(trim, 150); });
  window.addEventListener('pagehide', () => save());
  const start = () => {
    restore();
    const c = document.getElementById('ProductGridContainer');                 // filters re-render the grid
    if (c) new MutationObserver(() => { clearTimeout(t); t = setTimeout(trim, 50); }).observe(c, { childList: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  window.addEventListener('load', trim);
})();
